import { useCallback } from 'react';
import { LoginError } from '../../errorHandlers';

export const emailFetcher = async (
  email: string,
  recaptchaToken: string | null | undefined
): Promise<{
  exists: boolean;
  since: string;
  passwordReset: { force_password_reset: boolean };
}> => {
  const createResponse = await fetch('/api/check-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      recaptchaToken,
    }),
  });

  const { errors, data } = await createResponse.json();
  if (createResponse.status !== 200) {
    throw new LoginError(errors);
  }
  return data;
};

const useCheckEmail = () =>
  useCallback(
    async (email: string, recaptchaToken: string | null | undefined) => {
      const data = await emailFetcher(email, recaptchaToken);
      return data;
    },
    []
  );

export default useCheckEmail;
